<template>
  <div 
    :style="{color:pageTextColor,
             backgroundColor:parcelShopInfoBackgroundColor}"
    class="c-cbr-ReturnPlan-outer">
    <div class="c-cbr-ReturnPlan-headline">
      {{ $t(headline) }}</div>
    <div class="c-cbr-ReturnPlan-subHeadline">
      {{ $t('return.free') }}</div>
    <div class="c-cbr-ReturnPlan-content">
      <slot name="content"/>
    </div>
  </div>
</template>

<script>
  import ObjLink from "./ObjLink.vue";
import { mapGetters } from 'vuex'
  export default {
    components: {
      ObjLink,
    },
    props: {
      headline: {
        type: String,
        required: true
      },
      subHeadline: {
        type: String,
        required: true
      },
      isActive: {
        type: Boolean,
        required: false,
        default: false
      },
      val: {
        type: String,
        required: true
      }
    },
     computed: {
    ...mapGetters('config', ['pageTextColor','parcelShopInfoBackgroundColor'])
     }
  }

</script>



// WEBPACK FOOTER //
// client/components/CbrReturnPlan.vue